<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.42158 7.84948C8.41632 6.34256 12.1601 6.84052 14.6598 9.34336C17.0977 11.7843 17.631 15.41 16.2598 18.3693C16.4502 18.277 16.6387 18.1736 16.8248 18.0585C17.0095 17.9441 17.1019 17.887 17.1717 17.8593C17.3052 17.8064 17.4065 17.791 17.5497 17.8021C17.6246 17.8079 17.7094 17.8299 17.8791 17.874C18.947 18.1511 19.481 18.2897 19.8656 18.2113C20.5333 18.0753 21.055 17.5528 21.1909 16.8843C21.2692 16.4992 21.1308 15.9646 20.854 14.8954C20.81 14.7254 20.788 14.6404 20.7823 14.5652C20.7713 14.4218 20.7869 14.3192 20.84 14.1856C20.8679 14.1155 20.9249 14.0237 21.0389 13.8401C23.0973 10.5236 21.5043 6.50314 19.4935 4.48982C16.1779 1.17006 10.8023 1.17006 7.4867 4.48982C6.51149 5.46626 5.82312 6.62113 5.42158 7.84948Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.26219 21.2246C8.99586 22.9161 12.3641 21.5411 13.9524 19.9508C16.6828 17.2169 16.6828 12.7844 13.9524 10.0504C11.2219 7.31652 6.7949 7.31652 4.06441 10.0504C2.40847 11.7085 1.09657 15.0195 2.79173 17.7506C2.8856 17.9019 2.93254 17.9775 2.9555 18.0352C2.99926 18.1453 3.01212 18.2297 3.00307 18.3478C2.99833 18.4098 2.98021 18.4797 2.94398 18.6197C2.71604 19.5002 2.60207 19.9405 2.66654 20.2577C2.77843 20.8082 3.20813 21.2384 3.75795 21.3505C4.07473 21.415 4.51445 21.3009 5.39388 21.0727C5.53361 21.0364 5.60352 21.0183 5.66519 21.0135C5.78312 21.0044 5.86651 21.017 5.97648 21.0606C6.03399 21.0834 6.11006 21.1305 6.26219 21.2246ZM11.0002 15C11.0002 15.5523 11.4479 16 12.0002 16C12.5525 16 13.0002 15.5523 13.0002 15C13.0002 14.4477 12.5525 14 12.0002 14C11.4479 14 11.0002 14.4477 11.0002 15ZM8.00023 15C8.00023 15.5523 8.44794 16 9.00023 16C9.55251 16 10.0002 15.5523 10.0002 15C10.0002 14.4477 9.55251 14 9.00023 14C8.44794 14 8.00023 14.4477 8.00023 15ZM6.00023 16C5.44794 16 5.00023 15.5523 5.00023 15C5.00023 14.4477 5.44794 14 6.00023 14C6.55251 14 7.00023 14.4477 7.00023 15C7.00023 15.5523 6.55251 16 6.00023 16Z"
      fill="white"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "MessageIcon",
  props: {
    color: {
      type: String,
      default: "white",
    },
  },
})
</script>

<style lang="scss" scoped>
svg {
  display: flex;
}
</style>
